import { useStore } from '../state/store';
import { BankArea, RecordTable } from './BankArea';
import { Badge } from '../design/primitives';

export function Compliance() {
  const { bootstrap } = useStore();
  if (!bootstrap) return null;
  const { kycCases, customers } = bootstrap.records;

  const nameOf = (customerId: string) =>
    customers.find((customer: any) => customer.id === customerId)?.name ?? customerId;

  return (
    <BankArea
      serverName="compliance-kyc-mcp"
      lede="The compliance desk gives an agent the widest read access in the bank — every customer record, every sanctions result, every audit archive. That makes it the desk where the boundaries matter most: bulk export, record deletion and archive purges are refused outright."
    >
      <RecordTable
        title="KYC cases"
        columns={[
          { key: 'id', label: 'Case' },
          { key: 'customer', label: 'Customer' },
          { key: 'status', label: 'Status' },
          { key: 'screening', label: 'Sanctions screening' },
          { key: 'missing', label: 'Missing evidence' },
        ]}
        rows={kycCases.map((kycCase: any) => ({
          id: <code className="mb-mono">{kycCase.id}</code>,
          customer: nameOf(kycCase.customerId),
          status: (
            <Badge tone={kycCase.status === 'cleared' ? 'allow' : kycCase.status === 'escalated' ? 'block' : 'approval'}>
              {kycCase.status.replace('_', ' ')}
            </Badge>
          ),
          screening: (
            <Badge tone={kycCase.sanctionsScreening === 'clear' ? 'allow' : 'block'}>
              {kycCase.sanctionsScreening}
            </Badge>
          ),
          missing: kycCase.missingEvidence.length > 0 ? kycCase.missingEvidence.join('; ') : '\u2014',
        }))}
      />
    </BankArea>
  );
}
